import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faPlay, faPause, faChevronRight, faHome, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faTwitter, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

library.add(faPlay, faPause, faChevronRight, faHome, faSearch, faTimes, faFacebookF, faInstagram, faTwitter, faLinkedinIn);
dom.watch();
